import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const Container = ({
  children,
  maxWidth,
  disableGutters = false,
  gutters,
  className,
}) => (
  <div
    className={cx('hms-container', className, {
      'hms-container__no-gutters': disableGutters,
      [`hms-container__gutters-${gutters}`]: gutters,
    })}
    style={{ maxWidth }}
  >
    {children}
  </div>
);

Container.propTypes = {
  children: T.node.isRequired,
  maxWidth: T.oneOfType([T.number, T.string]),
  disableGutters: T.bool,
  // Default gutters size 24px
  // Supported sizes: 32
  // To add support more sizes, add appropriate styles to _hms-container.scss
  gutters: T.oneOfType([T.number, T.string]),
  className: T.string,
};

export default Container;
